module.exports = __webpack_public_path__ + "img/adaptations1.a3995d47.png";